/**
 * PDF Finalize Page
 * 
 * Wrapper page for the PDF Finalize component
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import PDFFinalize from '../components/PDFFinalize';
import MobileNav from '../components/MobileNav';

export default function PDFFinalizePage() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-zinc-950">
      <MobileNav />
      <PDFFinalize onClose={() => navigate('/')} />
    </div>
  );
}
